/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type PinSemanticViewMutationVariables = Types.Exact<{
  semanticViewId: Types.Scalars["SemanticViewId"]["input"];
  pinned: Types.Scalars["Boolean"]["input"];
}>;

export type PinSemanticViewMutation = {
  readonly __typename: "Mutation";
  readonly pinSemanticView: {
    readonly __typename: "SemanticView";
    readonly id: c.SemanticViewId;
    readonly pinned: boolean;
    readonly pinnedAt: c.DateTimeString | null;
  };
};

export type PinnedSemanticViewsCacheUpdateQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PinnedSemanticViewsCacheUpdateQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly pinnedSemanticViews: ReadonlyArray<{
      readonly __typename: "SemanticView";
      readonly id: c.SemanticViewId;
      readonly pinned: boolean;
      readonly pinnedAt: c.DateTimeString | null;
    }>;
  } | null;
};

export const PinSemanticViewDocument = /*#__PURE__*/ gql`
  mutation pinSemanticView(
    $semanticViewId: SemanticViewId!
    $pinned: Boolean!
  ) {
    pinSemanticView(semanticViewId: $semanticViewId, pinned: $pinned) {
      id
      pinned
      pinnedAt
    }
  }
`;
export type PinSemanticViewMutationFn = Apollo.MutationFunction<
  PinSemanticViewMutation,
  PinSemanticViewMutationVariables
>;

/**
 * __usePinSemanticViewMutation__
 *
 * To run a mutation, you first call `usePinSemanticViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinSemanticViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinSemanticViewMutation, { data, loading, error }] = usePinSemanticViewMutation({
 *   variables: {
 *      semanticViewId: // value for 'semanticViewId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function usePinSemanticViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinSemanticViewMutation,
    PinSemanticViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PinSemanticViewMutation,
    PinSemanticViewMutationVariables
  >(PinSemanticViewDocument, options);
}
export type PinSemanticViewMutationHookResult = ReturnType<
  typeof usePinSemanticViewMutation
>;
export type PinSemanticViewMutationResult =
  Apollo.MutationResult<PinSemanticViewMutation>;
export type PinSemanticViewMutationOptions = Apollo.BaseMutationOptions<
  PinSemanticViewMutation,
  PinSemanticViewMutationVariables
>;
export const PinnedSemanticViewsCacheUpdateDocument = /*#__PURE__*/ gql`
  query PinnedSemanticViewsCacheUpdate {
    me {
      id
      pinnedSemanticViews {
        id
        pinned
        pinnedAt
      }
    }
  }
`;

/**
 * __usePinnedSemanticViewsCacheUpdateQuery__
 *
 * To run a query within a React component, call `usePinnedSemanticViewsCacheUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedSemanticViewsCacheUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedSemanticViewsCacheUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePinnedSemanticViewsCacheUpdateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PinnedSemanticViewsCacheUpdateQuery,
    PinnedSemanticViewsCacheUpdateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PinnedSemanticViewsCacheUpdateQuery,
    PinnedSemanticViewsCacheUpdateQueryVariables
  >(PinnedSemanticViewsCacheUpdateDocument, options);
}
export function usePinnedSemanticViewsCacheUpdateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedSemanticViewsCacheUpdateQuery,
    PinnedSemanticViewsCacheUpdateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PinnedSemanticViewsCacheUpdateQuery,
    PinnedSemanticViewsCacheUpdateQueryVariables
  >(PinnedSemanticViewsCacheUpdateDocument, options);
}
export function usePinnedSemanticViewsCacheUpdateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PinnedSemanticViewsCacheUpdateQuery,
    PinnedSemanticViewsCacheUpdateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedSemanticViewsCacheUpdateQuery,
    PinnedSemanticViewsCacheUpdateQueryVariables
  >(PinnedSemanticViewsCacheUpdateDocument, options);
}
export type PinnedSemanticViewsCacheUpdateQueryHookResult = ReturnType<
  typeof usePinnedSemanticViewsCacheUpdateQuery
>;
export type PinnedSemanticViewsCacheUpdateLazyQueryHookResult = ReturnType<
  typeof usePinnedSemanticViewsCacheUpdateLazyQuery
>;
export type PinnedSemanticViewsCacheUpdateSuspenseQueryHookResult = ReturnType<
  typeof usePinnedSemanticViewsCacheUpdateSuspenseQuery
>;
export type PinnedSemanticViewsCacheUpdateQueryResult = Apollo.QueryResult<
  PinnedSemanticViewsCacheUpdateQuery,
  PinnedSemanticViewsCacheUpdateQueryVariables
>;
